import { useState } from 'react';
import { parsePrice, formatPrice } from '@shared/lib/format';

// Drop-in price input. Parent keeps a plain-digit string ("130000"); this shows accounting
// commas ("130,000") when not focused and accepts "130k" / "1.5m" / "130,000" while typing.
// onChange emits the parsed plain-integer string ("" when empty/invalid).
export function PriceInput({ value, onChange, placeholder, style }:
  { value: string; onChange: (v: string) => void; placeholder?: string; style?: React.CSSProperties }) {
  const [text, setText] = useState('');
  const [focused, setFocused] = useState(false);

  const display = focused ? text : (value ? formatPrice(Number(value)) : '');

  return (
    <input
      inputMode="decimal"
      value={display}
      placeholder={placeholder}
      style={style}
      onFocus={() => { setFocused(true); setText(value ? formatPrice(Number(value)) : ''); }}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^\d.,kmKM\s]/g, '');
        setText(raw);
        const n = parsePrice(raw);
        onChange(n != null ? String(n) : '');
      }}
      onBlur={() => setFocused(false)}
    />
  );
}
